module.exports = __webpack_public_path__ + "static/media/use_graph02_jpn.25b9c801.jpg";